(ns app.front.view.package.package-section
  (:require [app.front.entities :as entities]
            [app.front.view.workspace.section :as ws-section]
            [app.front.view.workspace.subs :as ws-subs]
            [core.front.carbon :as cc]
            [core.front.components :as components]
            [core.front.date-util :as date-util]
            [core.front.event :refer [<sub]]
            [core.front.icons :as i]
            [core.user.model :as user-model]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]))

(rf/reg-sub ::packages
  (fn [[_ workspace]]
    (rf/subscribe [::entities/entities {:entity/type   :entity.type/package-pdf
                                        :entity/parent (:db/id workspace)}]))
  (fn [packages _]
    (->> packages
         (sort-by :entity/created >)
         seq)))

(defn- package-list [{:keys [tr packages]}]
  [components/structured-list-keyed
   {:wrapper-opts {:aria-label (tr [:admin-package/packages])}}
   [(tr [:admin-package/created-on]) (tr [:admin-package/created-by]) (tr [:admin-package/status])
    (tr [:admin-package/package])]
   (->> packages
        (mapv (fn [package]
                (let [id    (:db/id package)
                      state (:domain/state package)]
                  {:name  id
                   :key   id
                   :cells [[:div (if-let [d (:entity/created package)]
                                   ((<sub [::date-util/date-time-fn]) d)
                                   "-")]
                           [:div (if-let [u (:entity/creator package)]
                                   (user-model/full-name u)
                                   "-")]
                           [:div (tr [state])]
                           [:div
                            (cond
                              (and (= state :package.state/ready)
                                   (:package-pdf/document package))
                              [:div
                               (cc/button
                                 {:kind             :primary
                                  :size             :small
                                  :icon             i/download
                                  :icon-description (tr [:admin-package/download])
                                  :href             (str "/api/command/package/download?id=" id
                                                         "&group-id=" (<sub [::ws-subs/authority-group-id]))}
                                 (tr [:admin-package/download]))]

                              (= state :package.state/generating)
                              (cc/inline-loading {:description (tr [:admin-package/generating])}))]]}))))])


(defn packages [{:keys [target-entity workspace tr] :as state}]
  (when-let [packages (<sub [::packages workspace])]
    [ws-section/section
     target-entity
     :admin-packages
     state
     (tr [:admin-package/admin-packages])
     true
     [:div
      [package-list (util/mmap tr packages)]]]))
